import React, { FC } from 'react';

import { CategoryType } from '~/templates/L2EventPage';

import Category from '../Category/Category';

interface CategoryListProps {
  categoryList: CategoryType[];
}

const CategoryList: FC<CategoryListProps> = ({ categoryList }) => (
  <div className="category-list">
    {categoryList.map((category) => (
      <Category category={category} />
    ))}
  </div>
);

export default CategoryList;
